import type { CSSProperties } from 'react';
import { BREAKPOINTS } from '@/app/constants';
import { TRANSPARENT_PIXEL_DATA_URI } from '@/app/utils';
import { getS1BannerAsset } from './s1-banner-assets';

/** 移动端用整图、不做视差。素材比例 960 × 410。 */
const S1_BANNER_MOBILE_RATIO = 960 / 410;

/**
 * 与 `sm`(max-width:767px) 互补。桌面端让 `<source>` 选中 1×1 data URI，
 * 这张整图才真正不走网络——只靠 `sm:block` 的话 `display: none` 仍然会发请求。
 */
const DESKTOP_BLANK_SOURCE_MEDIA = `(min-width: ${BREAKPOINTS.MD_MIN}px)`;

/**
 * S banner 的移动端整图。与 `S1BannerParallax`（桌面视差，传 `sm:hidden`）成对使用：
 * 两者始终都在 DOM 里，靠断点各自只在自己那一侧下载素材。
 */
export const S1BannerMobile = () => (
  <picture className="contents">
    <source media={DESKTOP_BLANK_SOURCE_MEDIA} srcSet={TRANSPARENT_PIXEL_DATA_URI} />
    <img
      src={getS1BannerAsset('mobile')}
      alt=""
      className="hidden w-full object-contain [aspect-ratio:var(--s1-banner-mobile-aspect-ratio)] sm:block"
      style={{ '--s1-banner-mobile-aspect-ratio': S1_BANNER_MOBILE_RATIO } as CSSProperties}
      loading="eager"
      decoding="async"
    />
  </picture>
);
